import React, { createContext, useState } from 'react'
const ScrollingGuideContext = createContext(null)
export const ScrollingGuideProvider = ({ children }) => {
  const [isShowTips, setIsShowTips] = useState(true)
  const toggleShowTips = (bool) => {
    setIsShowTips(bool)
  }
  return <ScrollingGuideContext.Provider value={{ isShowTips, toggleShowTips }}>{children}</ScrollingGuideContext.Provider>
}
export default ScrollingGuideProvider
export { ScrollingGuideContext }